import './style.css'
const ButtonSaveProduct = ({handleSubmit, loading, type, t}) => {
    return(
        <div className={loading ? 'button-yellow-container-floating disabled-button-yellow-container-floating' : 'button-yellow-container-floating' } onClick={!loading && handleSubmit}>
            <button>{type === 'add' ? t.merchant.product.labelSaveAdd : t.merchant.product.labelSaveEdit}</button>
        </div>
    )
}

export default ButtonSaveProduct